import PwaInstallBanner from './PwaInstallBanner.jsx';
import './PwaInstallBanner.css';

export default PwaInstallBanner;
